// export const host = 'http://localhost:8080/';
export const host = 'https://all-in-one-back-production-d521.up.railway.app/';
